import { Box, Typography } from "@mui/material";
import { FC } from "react";

interface Props {
  active?: boolean;
  title: string;
  onClick: () => void;
}

const MenuItem: FC<Props> = ({ active = false, title, onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        gap: "1rem",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <Box
        sx={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          background: active ? "#33636E" : "#9BBFC7",
          transition: "all .5s",
        }}
      />
      <Typography
        sx={{
          color: active ? "#33636E" : "#9BBFC7",
          fontSize: "14px",
          transition: "all .5s",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default MenuItem;
